<a [routerLink]="[]" class="z-50 px-4 text-[10.5px]">
  @if (patient$ | async) {
    <span class="flex items-center" (click)="editPatient()">
      <mat-icon class="!h-3 !w-3 !text-[10.5px]">edit</mat-icon> Edit Patient
    </span>
  } @else {
    <span class="flex items-center" (click)="addPatient()">
      <mat-icon class="!h-3 !w-3 !text-[10.5px]">add</mat-icon> Create Patient
    </span>
  }
</a>
